import { Dialog, documentFileUrl } from '@trippath/shared';
import { useTranslation } from 'react-i18next';

import { PdfView } from './PdfView';

/** A file kept as a document of the trip: its id, its name, what kind of file it is. */
export interface Viewed {
  id: string;
  name: string;
  /** `application/pdf` or `image/webp`; none while it has no file. */
  type: string | null | undefined;
}

interface Props {
  trip: string;
  file: Viewed;
  onClose: () => void;
}

/** A booking's, a ticket's or a thing's file shown in place: a PDF read with pdf.js, a photo. */
export function FileView({ trip, file, onClose }: Props) {
  const { t } = useTranslation();
  const url = documentFileUrl(trip, file.id);
  return (
    <Dialog open onClose={onClose} title={file.name} wide>
      <div className="file-view">
        {file.type === 'application/pdf' ? (
          <PdfView url={url} title={file.name} />
        ) : (
          <img className="file-view-image" src={url} alt={file.name} />
        )}
      </div>
      <div className="dialog-actions">
        <a className="text-link" href={url} target="_blank" rel="noreferrer">
          {t('plan.openFile')} ↗
        </a>
      </div>
    </Dialog>
  );
}
